module.exports = __webpack_public_path__ + "static/media/d9ru.3b6d71d3.pdf";